import { StyleSheet, View, type ViewProps } from 'react-native';

import { maxContentWidth } from '@/theme';

export type ContainerProps = ViewProps & {
  narrow?: boolean;
};

export function Container({ narrow, style, children, ...rest }: ContainerProps) {
  return (
    <View
      style={[
        styles.outer,
        { maxWidth: narrow ? 960 : maxContentWidth },
        style,
      ]}
      {...rest}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    width: '100%',
    marginHorizontal: 'auto',
    paddingHorizontal: 24,
  },
});
